// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".eo-grid[data-v-a028a7ae]{align-items:center;justify-items:center;place-items:center}@media(min-width:600px){.eo-grid[data-v-a028a7ae]{align-items:center;justify-items:start;place-items:center start}}.avatar[data-v-a028a7ae]{align-self:flex-start;height:150px;width:150px}@media(min-width:600px){.avatar[data-v-a028a7ae]{height:200px;width:200px}}@media(min-width:900px){.avatar[data-v-a028a7ae]{height:250px;width:250px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
